var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPatientBalance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0987549,
    width: 36,
    height: 36,
    rx: 8,
    fill: "#D9ECFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 27.0988V25.0988C23 24.0379 22.5786 23.0205 21.8284 22.2703C21.0783 21.5202 20.0609 21.0988 19 21.0988H11C9.93913 21.0988 8.92172 21.5202 8.17157 22.2703C7.42143 23.0205 7 24.0379 7 25.0988V27.0988M29 27.0988V25.0988C28.9993 24.2125 28.7044 23.3515 28.1614 22.6511C27.6184 21.9506 26.8581 21.4503 26 21.2288M22 9.22875C22.8604 9.44906 23.623 9.94946 24.1676 10.6511C24.7122 11.3527 25.0078 12.2156 25.0078 13.1038C25.0078 13.9919 24.7122 14.8548 24.1676 15.5564C23.623 16.2581 22.8604 16.7585 22 16.9788M19 13.0988C19 15.3079 17.2091 17.0988 15 17.0988C12.7909 17.0988 11 15.3079 11 13.0988C11 10.8896 12.7909 9.09875 15 9.09875C17.2091 9.09875 19 10.8896 19 13.0988Z",
    stroke: "#007DFA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientBalance);
export default __webpack_public_path__ + "static/media/patientBalance.8d2508efbecf363e3971cacc81adbba6.svg";
export { ForwardRef as ReactComponent };